import React, { useEffect, useState, useMemo } from 'react';
import { frameColumnsForAdditionalPaymentDetails } from '../../../../Member/utils/common';
import AdditionalPaymentTable from './AdditionalPaymentTable';
import AdditionalPaymentSkeleton from './skeleton/AdditionalPaymentSkelton';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';
import MasterPermissions from 'src/Admin/api/MasterPermissions';
import Httpheader from 'src/Admin/shared/httpheader';

const AdditionalPaymentDetails = ({ dataFetching, additioanlData }) => {
  const cName = Httpheader.getCNAME();
  console.log('AdditionalPaymentDetails dataFetching', dataFetching);

  const [additioanlPaymentDetails, setAdditioanlPaymentDetails] = useState({
    ClaimPayments: [],
  });
  const [paymentDetailsLoading, setPaymentDetailsLoading] = useState(false);
  const [paymentDetailsServerError, setPaymentDetailsServerError] =
    useState(false);

  const fetchAdditionalPaymentDetails = async (claimNumber) => {
    setPaymentDetailsLoading(true);
    try {
      const responseClaimDetails = await axiosInstance.get(
        APIEndpoints.getAdditionalPaymentDetailsResource() + claimNumber,
      );
      if (responseClaimDetails?.status === 200) {
        setAdditioanlPaymentDetails(
          responseClaimDetails?.data?.Response || { ClaimPayments: [] },
        );
      }
    } catch (error) {
      console.log(error);
      setPaymentDetailsServerError(true);
    } finally {
      setPaymentDetailsLoading(false);
    }
  };

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });

  const paymentData = additioanlPaymentDetails?.ClaimPayments?.map((item) => {
    return {
      PaymentId: item?.CheckNo,
      PayDate: item?.CheckIssueDate,
      PaymentMethod: item?.PaymentMethod,
      CheckingAccounts: item?.AccountID,
      PaymentReconciliationStatus: item?.ReconciliationStatus,
      PaymentAmount: item?.PayeeAmount,
    };
  });

  const columnNames = useMemo(() => {
    return frameColumnsForAdditionalPaymentDetails();
  }, [paymentData]);

  useEffect(() => {
    if (additioanlData?.Claimnumber)
      fetchAdditionalPaymentDetails(additioanlData?.Claimnumber);
  }, [additioanlData?.Claimnumber]);

  return (
    <div>
      {dataFetching || paymentDetailsLoading ? (
        <AdditionalPaymentSkeleton />
      ) : paymentDetailsServerError ? (
        <CustomClientError
          CustomClasses="p-0 m-0"
          ErrorHeading={'Something went wrong with request!'}
          ErrorMessage={'Please try again.'}
        />
      ) : (
        additioanlPaymentDetails?.ClaimPayments?.length > 0 && (
          <div className="additional-payment-details">
            {paymentData?.length > 0 && (
              <>
                <div className="title">Additional Payment Details</div>
                <div className="details-section">
                  <div className="details-section-table">
                    <div className="tr">
                      <div className="td">Withhold Amount</div>
                      <div className="td value">
                        {formatter.format(
                          additioanlPaymentDetails?.WithholdAmount,
                        )}
                      </div>
                      <div className="td">Encounter Amount</div>
                      <div className="td value">
                        {formatter.format(
                          additioanlPaymentDetails?.EncounterAmount,
                        )}
                      </div>
                      <div className="td">ITS Fee Details</div>
                      <div className="td">
                        {formatter.format(additioanlData?.ITSFeeDetails || 0)}
                      </div>
                    </div>
                    <div className="tr">
                      <div className="td">Adjustment Amount</div>
                      <div className="td value">
                        {formatter.format(
                          additioanlPaymentDetails?.AdjustmentAmount,
                        )}
                      </div>
                      <div className="td">Late Payment Penalty Amount</div>
                      <div className="td value">
                        {formatter.format(
                          additioanlData?.LatePaymentdetails || 0,
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="claims-list-grid additional-table-grid">
              <AdditionalPaymentTable
                className="account-table"
                columns={
                  MasterPermissions.CheckPermission('Download EOP') &&
                  (cName.includes('mybenefits') || cName.includes('roundstone'))
                    ? columnNames
                    : columnNames?.filter(
                        (item) => item?.accessor !== 'DownloadEOP',
                      )
                }
                data={paymentData || []}
                keyField={
                  MasterPermissions.CheckPermission('Download EOP') &&
                  (cName.includes('mybenefits') || cName.includes('roundstone'))
                    ? columnNames
                    : columnNames?.filter(
                        (item) => item?.accessor !== 'DownloadEOP',
                      )
                }
                dataFetching={dataFetching}
                paymentDetailsServerError={paymentDetailsServerError}
                claimNumber={additioanlData?.Claimnumber}
              />
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default AdditionalPaymentDetails;
